/* Related products — swaps in Shopify's product recommendations */
(function () {
  function init(section) {
    var url = section.getAttribute('data-recommendations-url');
    if (!url || section.hasAttribute('data-recommendations-loaded')) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = doc.querySelector('[data-recommendations-grid]');
        var target = section.querySelector('[data-recommendations-grid]');
        if (!target) return;
        if (grid && grid.querySelector('.card-ShopTheCollection')) {
          target.innerHTML = grid.innerHTML;
        } else if (!target.querySelector('.card-ShopTheCollection')) {
          section.hidden = true;
        }
      })
      .catch(function () {});
  }

  if (window.Anagenesis && window.Anagenesis.register) {
    window.Anagenesis.register('related-products', init);
  }
})();
